import { Windows95Window } from "../Windows95Window";
import { IWindowState } from "../../Types/IWindowState";
import { PlayerDataSingleton } from "../../Logic/PlayerDataSingleton";
import { CRTEffectHandler } from "../../UI/CRTEffectSingleton";
import { NineSlicePlane, Text, TextStyle, Texture } from "pixi.js";
import { GAME_FONT, GAME_FONT_BOLD } from "../../Constants/Constants";
import { GameObject, HelperFunctions } from "../../../tsthree";
import { buttonify } from "../../../engine/HelperFunctions/buttonify";
import { AUDIO_TYPES } from "../../../engine/AudioSingleton";
import { Windows95 } from "../../States/Windows95";

enum SETTINGS_TYPES {
    Tickbox,
    Action,
    NUM_OF_TYPES
}

const SETTINGS_DEFINITION: Record<string, {
    type: SETTINGS_TYPES;
    get: () => any;
    set: (_val: any) => void;
}> = {
    "Mute Music": {
        type: SETTINGS_TYPES.Tickbox,
        get: () => PlayerDataSingleton.getIsMusicMuted(),
        set: (_val: any) => {
            PlayerDataSingleton.setMusicMuted(_val as boolean);

            if(!_val) {
                HelperFunctions.playSound_s("Warmth", {
                    loop: true,
                    volume: 0.5,
                    audioType: AUDIO_TYPES.MUSIC
                })
                    .then((s) => {
                        (ENGINE.getActiveState() as Windows95)["_musicId"] = s;
                    });
            } else {
                HelperFunctions.stopAllSoundsOfId("Warmth");
            }
        }
    },
    "Mute SFX": {
        type: SETTINGS_TYPES.Tickbox,
        get: () => PlayerDataSingleton.getIsSFXMuted(),
        set: (_val: any) => {
            PlayerDataSingleton.setIsSFXMuted(_val as boolean);
        }
    },
    "Enable CRT effect": {
        type: SETTINGS_TYPES.Tickbox,
        get: () => PlayerDataSingleton.getCRTEffectEnabled(),
        set: (_val: any) => {
            PlayerDataSingleton.setCRTEffectEnabled(_val as boolean);
            if(_val) {
                CRTEffectHandler.addToGame();
            } else {
                CRTEffectHandler.removeFromGame();
            }
        }
    },
    // "24hr clock": {
    //     type: SETTINGS_TYPES.Tickbox,
    //     get: () => PlayerDataSingleton.getUse24HrClock(),
    //     set: (_val: any) => {
    //         PlayerDataSingleton.setUse24HrClock(_val as boolean);
    //         (ENGINE.getActiveState() as Windows95).refreshMailUI();
    //     }
    // },
    // "Enable auto-login": {
    //     type: SETTINGS_TYPES.Tickbox,
    //     get: () => PlayerDataSingleton.getShouldAutoLogin(),
    //     set: (_val: any) => {
    //         PlayerDataSingleton.setShouldAutoLogin(_val as boolean);
    //     }
    // },
    "Enable auto-fullscreen": {
        type: SETTINGS_TYPES.Tickbox,
        get: () => PlayerDataSingleton.getShouldAutoFullscreen(),
        set: (_val: any) => {
            PlayerDataSingleton.setShouldAutoFullscreen(_val as boolean);
        }
    }
};

class TickboxPrefab extends GameObject {

    private static textStyle: TextStyle = new TextStyle({
        fontSize: 11,
    });

    private _isTicked: boolean = false;

    public set isTicked(val: boolean) {
        this._isTicked = val;
    }

    public get isTicked(): boolean {
        return this._isTicked;
    }

    constructor(_setState: (_val: boolean) => void, _isTicked?: boolean) {
        super("TickboxPrefab");

        this._isTicked = _isTicked || false;

        const box = new NineSlicePlane(
            ENGINE.getPIXIResource("inner-container-nineslice") as Texture
        );
        box.position.set(-6, -6);
        box.width = 12;
        box.height = 12;
        this.addChild(box);

        const tickmark = new Text("✔️", TickboxPrefab.textStyle);
        tickmark.anchor.set(0.5);
        tickmark.position.set(0, 0);
        this.addChild(tickmark);
        tickmark.visible = this._isTicked;

        buttonify(
            this,
            {
                onFire: () => {
                    _setState((this._isTicked = !this._isTicked));
                    tickmark.visible = this._isTicked;
                }
            }
        );
    }
}

export class Win95SettingsWindow extends Windows95Window {
    constructor(_settings: {
        onClose: () => void;
        onMinimise: () => void;
        windowStateRef: IWindowState<Win95SettingsWindow>
    }) {
        super({
            title: "Settings",
            iconKey: "settings-icon-24px",
            dimensions: {
                width: 170,
                height: 260,
            },
            windowStateRef: _settings.windowStateRef,
            onClose: () => _settings.onClose(),
            onMinimise: () => _settings.onMinimise(),
        });

        const optionsKeys = Object.keys(SETTINGS_DEFINITION);
        const sharedTextStyle = new TextStyle({
            fontFamily: GAME_FONT,
            fontSize: 11,
            align: "left"
        });
        optionsKeys.forEach((e: string, i) => {
            const text = new Text(e, sharedTextStyle);
            text.position.set(
                4,
                30 + 4 + (12 * i),
            );
            this.contentContainer.addChild(text);

            switch(SETTINGS_DEFINITION[e].type) {
                case SETTINGS_TYPES.Tickbox:
                    const tickbox = new TickboxPrefab(
                        SETTINGS_DEFINITION[e].set,
                        SETTINGS_DEFINITION[e].get()
                    );
                    tickbox.position.set(170 - 11, text.position.y + (text.height * 0.5));
                    this.contentContainer.addChild(tickbox);
                    break;
            }
        });

        const versionText = new Text("Version: " + __VERSION, sharedTextStyle);
        versionText.position.set(170 - 2, 260 - 36);
        versionText.anchor.set(1, 1);
        this.contentContainer.addChild(versionText);
    }
}